module.exports = __webpack_public_path__ + "img/LOGO1.0547e8a5.svg";